module.exports = __webpack_public_path__ + "static/media/abhishekkumar.a9af4348.jpg";